import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { SOPO_DIALOG_DATA, SopoDialogRef } from "../../interfaces/dialog";
import { GOLDS } from "@soposopo/sopo-models";
import { GoldIds } from "@soposopo/sopo-models/dist/shop/Golds";
import { firstValueFrom } from "rxjs";
import { CoinflowService } from "src/app/shared/services/coinflow/coinflow.service";
import { ShopAnimationPartToPlay } from "src/app/shared/services/purchase-animation/purchase-animation.service";

// Format price with decimals only when needed (e.g., $5 vs $4.99)
function formatPrice(amount: number): string {
  return amount % 1 === 0 ? `$${amount}` : `$${amount.toFixed(2)}`;
}

export type PaymentOption = 'walletBalance' | 'payNow';

@Component({
  selector: 'sopo-coinflow-shop',
  templateUrl: './sopo-coinflow-shop.component.html',
  styleUrls: [ './sopo-coinflow-shop.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SopoCoinflowShopComponent implements OnInit, OnDestroy {
  public selected: PaymentOption = 'payNow';
  public buttonText: 'SELECT AN OPTION' | 'CONFIRM PURCHASE' = 'CONFIRM PURCHASE';
  public sopoWalletBalance = "0";
  public productPrice: string;
  public sopoWalletProductPrice: string;

  private productId: string;
  private product: typeof GOLDS[GoldIds];
  private playAnimation: ShopAnimationPartToPlay;

  constructor(
    private sopoDialogRef: SopoDialogRef,
    private ref: ChangeDetectorRef,
    @Inject(SOPO_DIALOG_DATA) data: ISopoCoinflowSetting,
    private coinflowService: CoinflowService,
  ) {
    if (data.productId) {
      this.productId = data.productId;
    }
    if (data.product) {
      this.product = data.product;
    }
    if (data.playAnimation) {
      this.playAnimation = data.playAnimation;
    }
    if (data.price) {
      this.productPrice = data.price;
    }
  }

  ngOnInit(): void {
    this.initialize();
  }

  private async initialize(): Promise<void> {
    // Set wallet balance
    this.sopoWalletBalance = (await firstValueFrom(this.coinflowService.sopoWalletBalance)).toFixed(2);

    // Set product price from Firestore config
    const sopoShopProductPrice = this.coinflowService.sopoShopProductPrice;
    if (sopoShopProductPrice && sopoShopProductPrice[this.productId as GoldIds]) {
      this.sopoWalletProductPrice = formatPrice(sopoShopProductPrice[this.productId as GoldIds]);
    }

    this.ref.detectChanges();
  }

  public getDisplayPrice(): string {
    return this.sopoWalletProductPrice || this.productPrice;
  }

  public async purchase(): Promise<void> {
    this.sopoDialogRef.close();

    if (this.selected === 'walletBalance') {
      await this.coinflowService.sopoWalletPurchase(this.productId as GoldIds, this.product, this.playAnimation);
    } else {
      await this.coinflowService.coinflowWebviewPurchase(this.productId as GoldIds, this.product, this.playAnimation);
    }
  }

  cancel() {
    this.sopoDialogRef.close();
  }

  ngOnDestroy(): void {

  }
}

export interface ISopoCoinflowSetting {
  productId: string,
  product: typeof GOLDS[GoldIds],
  playAnimation: ShopAnimationPartToPlay,
  price: string;
}
